export const sortPoisAndAgms = (pois, agms) => {
    //create map of pois where they are grouped by upstream site
    //in each group, pois are sorted by distance to upstream site
    const poiMap = new Map();

    pois.forEach(poi => {
      if (!poiMap.has(poi.US_Site)) {
        poiMap.set(poi.US_Site, []);
      }
      poiMap.get(poi.US_Site).push(poi);
    });

    poiMap.forEach(poiList => {
      poiList.sort((a, b) => a.Dist_To_US - b.Dist_To_US);
    });

    //combine agms and pois
    const combinedArray = [];

    //track which pois we've placed, so we can catch any that don't belong to an agm below
    const placedPois = new Set();

    agms.forEach(agm => {
      //add agm
      combinedArray.push(agm);

      //add the POIs that are downstream from current AGM, using sorted POIs in map
      const poisForAGM = poiMap.get(agm.AGMID) || [];
      combinedArray.push(...poisForAGM);

      poisForAGM.forEach(poi => placedPois.add(poi));
    });

    //Julia/Claude July 28 2026: this function used to build its result purely by looping agms, so any poi
    //whose US_Site didn't match an AGMID was dropped without warning - and with no agms at all it returned
    //an empty array, silently emptying the table. a new poi has no US_Site until lat/lng are entered and the
    //upstream site is calculated, so this was reachable in normal use.
    //positioned pois are still placed under their agm exactly as before - anything we can't position now goes
    //on the end instead of disappearing
    const unpositionedPois = pois.filter(poi => !placedPois.has(poi));

    combinedArray.push(...unpositionedPois);

    return combinedArray;
}
